import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';
import SwitchFilter from '@/app/_components/widgets/SwitchFilter';
import { useEffect } from 'react';
import Modal from 'react-modal';
import { useRouterParams } from '@/app/_hooks/useRouterParams';
import ContactUsWidget from '@/app/_components/widgets/ContactUsWidget';

export default function SearchAside({
  count,
  openMobileSide,
  onCloseModalHandler,
}) {
  const { clearParams, setParam, setParams } = useRouterParams();

  const customStyles = {
    content: {
      top: '0',
      right: '0',
      width: '300px',
      bottom: '0',
      border: 'none',
      inset: 'unset',
      height: '100%',
    },
    overlay: {
      background: '#8686866e',
      overflow: 'auto',

      zIndex: '20',
    },
  };
  const resetFilters = () => {
    clearParams();
  };

  useEffect(() => {
    if (openMobileSide) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [openMobileSide]);

  const handleOfflineFilter = (e) => {
    if (e.target.checked) {
      setParams({ [e.target.name]: 0, stock: 1 });
    } else {
      setParams({ [e.target.name]: null, stock: null });
    }
  };

  const handleCheckBoxFilter = (e) => {
    if (e.target.checked) {
      setParam(e.target.name, 1);
    } else {
      setParam(e.target.name);
    }
  };

  return (
    <>
      <div className="hidden lg:block">
        <div className="w-[305px] test brand-sidebar pl-4">
          <div className="stick-sidebar sticky top-0">
            <div className="hidden lg:block">
              <ContactUsWidget />
            </div>
            <div className="sidebar-head flex justify-between p-4 pt-0">
              <span className="">فیلترها</span>
              <span
                className="text-xs text-ocean-blue cursor-pointer"
                onClick={resetFilters}
              >
                حذف فیلترها
              </span>
            </div>
            <div className="filters-archive">
              {/* <CategoryFilters
                Categories={categories}
                onChange={handleFilter}
              />
              <BrandFilters brands={brands} onChange={handleFilter} /> */}
              <SwitchFilter
                title="فقط کالاهای موجود"
                name="stock"
                onChange={handleCheckBoxFilter}
              />
              <SwitchFilter
                title="فقط کالاهای تخفیف دار"
                name="discount"
                onChange={handleCheckBoxFilter}
              />
              <SwitchFilter
                title="فقط کالاهای قابل خرید آنلاین"
                name="offline"
                onChange={handleOfflineFilter}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="block lg:hidden">
        <Modal
          isOpen={openMobileSide}
          onRequestClose={onCloseModalHandler}
          style={customStyles}
          ariaHideApp={false}
        >
          <div className="sidebar-head flex justify-between p-4 pt-0">
            <span className="">فیلترها</span>
            <span className="text-xs text-ocean-blue">حذف فیلترها</span>
          </div>
          {/* <CategoryFilters Categories={categories} onChange={handleFilter} />
          <BrandFilters brands={brands} onChange={handleFilter} /> */}
          <SwitchFilter
            title="فقط کالاهای موجود"
            name="stock"
            onChange={handleCheckBoxFilter}
          />
          <SwitchFilter
            title="فقط کالاهای تخفیف دار"
            name="discount"
            onChange={handleCheckBoxFilter}
          />
          <SwitchFilter
            title="فقط کالاهای قابل خرید آنلاین"
            name="offline"
            onChange={handleCheckBoxFilter}
          />
          <div
            className="productFilterCounts flex justify-between text-sm border-t border-light-gray-200 mt-8 py-6"
            onClick={onCloseModalHandler}
          >
            <span>مشاهده {count} کالا</span>
            <ArrowTop />
          </div>
        </Modal>
      </div>
    </>
  );
}
